import type { BulkImportEntity, BulkImportTemplateEntity } from '@/types/bulkImport'

export const bulkImportBasePath = (entity: BulkImportEntity): string =>
  `/manager/${entity}/imports`

export const combinedImportsPath = '/manager/imports'

export const bulkExportsPath = '/manager/bulk_exports'

export const bulkImportTemplateFileNames: Record<BulkImportTemplateEntity, string> = {
  users: 'modelo_usuarios_cartao_corp.xlsx',
  vehicles: 'modelo_veiculos_cartao_frota.xlsx',
}

export const bulkImportExportFileNames: Record<BulkImportEntity, string> = {
  users: 'edicao_usuarios_corp.xlsx',
  vehicles: 'edicao_veiculos_corp.xlsx',
  cards: 'edicao_cartoes_corp.xlsx',
}
